"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceRequestTypeInternalName = void 0;
var ServiceRequestTypeInternalName;
(function (ServiceRequestTypeInternalName) {
    ServiceRequestTypeInternalName["Repair"] = "REPAIR";
    ServiceRequestTypeInternalName["Maintenance"] = "MAINTENANCE";
    ServiceRequestTypeInternalName["Install"] = "INSTALL";
    ServiceRequestTypeInternalName["Estimate"] = "ESTIMATE";
    ServiceRequestTypeInternalName["Diagnostic"] = "DIAGNOSTIC";
})(ServiceRequestTypeInternalName = exports.ServiceRequestTypeInternalName || (exports.ServiceRequestTypeInternalName = {}));
